import { useQuery } from '@tanstack/react-query';
import type { CompetitorRun, CursorPage } from '@seo/types';
import { apiGet } from '@/lib/api';

export function useCompetitorRuns(projectId?: string, limit = 50) {
  const params = new URLSearchParams();
  if (projectId) params.set('project_id', projectId);
  params.set('limit', String(limit));
  return useQuery({
    queryKey: ['competitor-runs', { projectId, limit }],
    queryFn: () =>
      apiGet<CursorPage<CompetitorRun>>(`/v1/competitor-runs?${params.toString()}`),
  });
}
